import http from 'unsubscribe-ui/api/httpClient';
export const savePreferences = (subscribedIds, unsubscribedIds, dataParam) => {
  const URL = `/subscription-preferences/v2/preferences/update?data=${dataParam}`;
  return http.post(URL, JSON.stringify({
    subscribedIds,
    unsubscribedIds
  }));
};
export const unsubscribeAll = dataParam => {
  const URL = `/subscription-preferences/v2/preferences/unsubscribe-all?data=${dataParam}`;
  return http.post(URL);
};
export const unsubscribeSingle = dataParam => {
  const URL = `/subscription-preferences/v2/preferences/unsubscribe-single?data=${dataParam}`;
  return http.post(URL);
};
export const confirmRecipient = (dataParam, email, language, isUnsubscribeAll) => {
  const URL = `/subscription-preferences/v2/preferences/confirm-recipient?language=${language}`;
  return http.put(URL, JSON.stringify({
    data: dataParam,
    email,
    unsubscribeAll: isUnsubscribeAll
  }));
};
export const loadPreferences = dataParam => {
  const URL = `/subscription-preferences/v2/preferences/load?data=${dataParam}`;
  return http.get(URL);
};
export const companyInformation = (dataParam, languageParam) => {
  const URL = `/subscription-preferences/v2/preferences/company-information?data=${dataParam}&language=${languageParam}`;
  return http.get(URL);
};